import { bindable, computedFrom, autoinject } from 'aurelia-framework';
import { IMeasureInputAM, IMeasureInputRuleReferenceAM, MeasureEntryAM } from "../../services/measure-service";
import { ResourcedNotificationService, NotificationType } from "../../../../components/notifications/notification-service"
import { filter, first } from "lodash";
import { ResourceService } from '../../../../utils/resourceService';
import { CustomerMunicipalityWithServiceInvolvementField } from './measure-input-group-view';

@autoinject
export class MeasureInput {

	@bindable unit: string;
	@bindable measureEntry: MeasureEntryAM;
	@bindable comparisonMeasureEntry: MeasureEntryAM;
	@bindable autosaveAction: (params: any) => void;
	@bindable showComparisonValue : boolean;
	@bindable readonly: boolean;
	@bindable measuredForThisMunicipality: boolean;
	@bindable ruleReferenceInfo: IMeasureInputRuleReferenceAM;
	@bindable customerMunicipality: CustomerMunicipalityWithServiceInvolvementField;
	@bindable groupTitle: string;
	@bindable itemTitle: string;
	@bindable measureInput: IMeasureInputAM;

	inputField: HTMLInputElement;
	oldValue: any;

	constructor(private notificationService: ResourcedNotificationService, private resourceService: ResourceService) {
	}


	stateCssClasses: string;

	calculateCssClasses(): void {

		let state = [];
		const hasValue = this.measureEntry.value ? "value-set value-set--ok" : "value-set value-set--empty";
		state.push(hasValue);
		const isValid = this.measureEntry.validationResultOk ? "is-valid" : "not-valid";
		state.push(isValid);
		this.stateCssClasses = state.join(" ");
	}

	@computedFrom('measureEntry.isCollected')
	get tooltipText() : string{
		return this.measureEntry.isCollected ? '' : this.resourceService.getResource("MeasuresInputContainer_Tooltip_ValueIsNotMeasured");
	}

	@computedFrom('customerMunicipality', 'measureEntry', 'groupTitle')
	get inputLabel(): string {
		const measureInputNameWithSpecifier = this.measureInput.measureName + (this.measureInput.measureSpecifier ? `, ${this.measureInput.measureSpecifier}` : '');
		if (this.customerMunicipality) {
			return this.resourceService.getResource("MeasuresInputContainer_MeasureLabel_InputFieldWithMunicipality", [this.groupTitle, measureInputNameWithSpecifier, this.customerMunicipality.name]);
		} else {
			return this.resourceService.getResource("MeasuresInputContainer_MeasureLabel_InputField", [this.groupTitle, measureInputNameWithSpecifier]);
		}
	}

	@computedFrom('customerMunicipality', 'measureEntry', 'groupTitle')
	get inputName(): string {
		const municipality = this.customerMunicipality ? this.customerMunicipality.name : 'Yhteens�';
		const measureInputNameWithSpecifier = this.measureInput.measureName + (this.measureInput.measureSpecifier ? `, ${this.measureInput.measureSpecifier}` : '');

		const name = `${this.groupTitle}_${this.itemTitle}_${municipality}_${measureInputNameWithSpecifier}`;
		return name;
	}


	onMeasureInputBlur() {

		this.measureEntry.validateAndNormalize();
		this.calculateCssClasses();

		if (this.measureEntry.validationResultOk) {
			if(this.measureEntry.value !== this.oldValue) {
				const params = { measureEntry: { ...this.measureEntry, hasRuleReferences: this.ruleReferenceInfo != null }};
				this.autosaveAction(params);
				this.oldValue = this.measureEntry.value;
			}
		} else {
			let errorMsg = this.measureEntry.validationError;
			if (errorMsg != null) {
				this.notificationService.push(errorMsg.resourceKey, NotificationType.Warning, null, errorMsg.params);
			}
		}
	}

	attached() {
		this.oldValue = this.measureEntry.value;
	}

	copyComparisonValue(){
		if(this.measureEntry.value !== this.comparisonMeasureEntry.value) {
			this.measureEntry.value = this.comparisonMeasureEntry.value;
			this.onMeasureInputBlur();
		}
	}
}
